<template>
  <div class="row">
    <div class="col-md-12">
      <gestiune-stocuri-form :route="route" @on-submit="onPageSubmit"></gestiune-stocuri-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import GestiuneStocuriForm from './ManagementWastedForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      GestiuneStocuriForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        pageModel: {},
        page: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onPageSubmit (model, isValid) {
        this.pageModel = model
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Wasted/ManagementWastedEdit.vue